import { render, staticRenderFns } from "./WaitEmailVerification.vue?vue&type=template&id=395c728a"
import script from "./WaitEmailVerification.vue?vue&type=script&lang=js"
export * from "./WaitEmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports